export default "__VITE_ASSET__IGYblpuI__"